import { Box } from '@chakra-ui/react';
import MainDoodle from 'images/doodles/yellow-marker-big.png';
import Image from 'next/image';

import { FreeEbooksDoodle } from '@/components/sections/library/components/FreeEbooksDoodle/FreeEbooksDoodle';

export const LibraryAllBackground = ({ showMore }: { showMore?: boolean }) => {
  return (
    <>
      <Box
        position="absolute"
        display={{
          base: 'none',
          xs: 'initial',
        }}
        top={{
          base: 6,
          xs: 2,
          sm: 6,
          lg: '86px',
        }}
        right={{
          base: 6,
          xs: 0,
          sm: 6,
          md: 12,
        }}
        zIndex={0}
      >
        <FreeEbooksDoodle
          w={{
            base: '155px',
            md: '220px',
          }}
          transform={{
            xs: 'rotate(35deg)',
            sm: 'none',
          }}
        />
      </Box>
      <Box
        as={Image}
        src={MainDoodle}
        alt=""
        maxW={{
          base: '690px',
          sm: '864px',
          md: '1276',
        }}
        top={{
          base: '12rem',
          xs: showMore ? '8%' : '18%',
          sm: '20%',
          md: '18%',
        }}
        left={{
          base: '-18%',
          xs: '18%',
          md: '14%',
          xl: '30vw',
          '3xl': '24vw',
        }}
        position="absolute"
        zIndex={-1}
      />
    </>
  );
};
